<app-loading-screen [statusKey]="statusKey()" [failed]="failed()" />
